import { useAppSelector } from '../store/hooks';
import { selectIsGlobalAdmin } from '../store/permissions/permissionsSlice';

export function useIsAccountAdmin(): boolean {
  return useAppSelector(selectIsGlobalAdmin);
}
